import { COOKIES } from "constants/cookies";
import { getCookie } from "./cookies";

const handleDecagonChat = () => {
  const decagonOpen = getCookie(COOKIES.DECAGON_OPEN);
  const isDecagonOpened = decagonOpen === "true";
  if (window.duet && !isDecagonOpened) {
    window.duet.open();
  }
};

export { handleDecagonChat };
